import authStorageConfig from './authStorageConfig'

export const localStorageConfigs = [authStorageConfig]

export default localStorageConfigs
